import React from 'react';
import { useSidebar } from '../../context/SidebarContext';
import defaultImage from '../../assets/images/image.jpeg';

const DashboardHeader = ({ fullName, image }) => {
  const { toggle } = useSidebar();

  return (
    <header className="dashboard-header">
      <button onClick={toggle} className="menu-btn" aria-label="Toggle menu">
        <i className="material-icons">menu</i>
      </button>

      <h1>Dashboard</h1>

      <div className="profile-section">
        <span className="profile-name">{fullName}</span>
        <div className="profile-avatar">
          <img
            src={image || defaultImage}
            alt="Profile"
            crossOrigin="anonymous"
            onError={(e) => { e.target.src = defaultImage; }}
          />
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
